var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 1417.3",
    style: {
      enableBackground: "new 0 0 1417.3 1417.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000073707478492858767500000017590238333192962449_);}\n\t.st1{fill:#34394D;}\n\t.st2{fill:#F7EAE1;}\n\t.st3{fill:#141125;}\n\t.st4{fill:#EE7657;}\n\t.st5{fill:#293044;}\n\t.st6{fill:#E84222;}\n\t.st7{fill:#313336;}\n\t.st8{fill:#F28E76;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 152.9,
    y: 461,
    width: 1110.7,
    height: 494.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088112554683467259870000008270982174817836446_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2988",
    style: {
      clipPath: "url(#SVGID_00000088112554683467259870000008270982174817836446_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19998",
    className: "st1",
    d: "M610.1,577.5c-93-11.8-186.9-13.8-280.3-6c-110,8.7-165.6,39.6-173.7,81.8 c-8,42.2-3.4,87.2,37.5,94.5c40.9,7.4,503.5,4,503.5,4s66.4-5.4,91.2,11.4c15.9,10.9,31,23,45.3,36c0,0-1.7-65.5-7.7-84.3 S679.9,617,679.9,617L610.1,577.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19999",
    className: "st2",
    d: "M357.4,621.7c0,0,81.1,7.4,117.3,10.7s99.9,10.7,118.7,29.5s23.1,38.2,26.1,48.3 c3,10.1,2,33.7,2,33.7l-279.1,2.5c-6.5-19.1-8.9-39.3-7-59.3C340.9,640.8,357.4,621.7,357.4,621.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20000",
    className: "st3",
    d: "M204.7,639.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.6,0.4-1.2,1-1.5c27.9-12.4,107.7-19.3,153.5-16.2 c0.9,0.1,1.6,0.8,1.5,1.7c-0.1,0.9-0.8,1.6-1.7,1.5l0,0c-45.4-3.1-124.4,3.7-151.9,16C205.1,639.4,204.9,639.4,204.7,639.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20001",
    className: "st4",
    d: "M593.9,745.1L593.9,745.1c-0.9,0-1.6-0.8-1.6-1.7c0.5-30.3-6.8-51-21.4-61.5 c-0.7-0.6-0.8-1.6-0.2-2.3c0.5-0.6,1.4-0.8,2.1-0.4c15.6,11.2,23.3,32.8,22.8,64.2C595.5,744.3,594.8,745.1,593.9,745.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20002",
    className: "st4",
    d: "M569,746.1c-0.9,0-1.6-0.7-1.6-1.6v-0.6c0-23.2-5.8-40.1-17.3-50c-0.7-0.6-0.8-1.6-0.3-2.3 c0.6-0.7,1.6-0.8,2.3-0.3c0,0,0.1,0.1,0.1,0.1c12.3,10.6,18.5,28.2,18.4,52.5v0.5C570.6,745.3,569.9,746.1,569,746.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20003",
    className: "st4",
    d: "M539.6,746.1c-0.7,0-1.3-0.5-1.6-1.1l-4.6-13.9c-3.6,4.5-11.9,13.4-21.8,15 c-0.9,0.1-1.7-0.5-1.9-1.4c-0.1-0.9,0.5-1.7,1.4-1.9c11.7-1.9,21.4-16,21.5-16.2c0.5-0.8,1.5-1,2.3-0.4c0.3,0.2,0.5,0.5,0.6,0.9 l5.5,16.8c0.3,0.9-0.2,1.8-1,2.1C539.9,746,539.8,746.1,539.6,746.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20004",
    className: "st4",
    d: "M605.7,745.6c-0.8,0-1.6-0.7-1.6-1.5c-1-10.9,5.2-21.2,15.3-25.5c0.8-0.4,1.8,0,2.2,0.8 c0.4,0.8,0,1.8-0.8,2.2c-8.8,3.7-14.2,12.7-13.4,22.3c0.1,0.9-0.6,1.7-1.5,1.8c0,0,0,0,0,0C605.8,745.6,605.7,745.6,605.7,745.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20005",
    className: "st5",
    d: "M699.3,747.4c-0.8,0-1.5-0.6-1.6-1.4c-2.7-18.7-3.4-50.8-3.4-51.2c0-0.9,0.7-1.6,1.6-1.7 c0.9,0,1.6,0.7,1.7,1.6c0,0.3,0.7,32.3,3.3,50.8c0.1,0.9-0.5,1.7-1.4,1.9c0,0,0,0,0,0C699.5,747.4,699.4,747.4,699.3,747.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20006",
    className: "st6",
    d: "M612.2,567.4c-4.7-11.4-6.7-38.9,7.4-55c14.1-16.1,35.5-21.5,49.6-16.1 c14.1,5.4,22.1-18.8,38.2-26.8s28.2,0.7,43.6,9.4s29.5-14.8,57-17.4s47.6,6,57.6,24.8c9,16.8,4,36.2,16.1,42.2 c12.1,6,48.3-2,68.4,13.4c20.1,15.4,20.1,35.5,33.5,56.3c13.4,20.8,52.3,4,79.8,33.5c27.5,29.5,22.1,52.3,22.8,70.4 c0.7,18.1,26.8,32.9,37.5,32.2s36.9-2,50.3,19.4c13.4,21.5,10.1,32.2,20.8,36.9c10.7,4.7,33.5,14.8,31.5,35.5 c-2,20.8-14.1,27.5-4,37.5c10.1,10.1,23.5,8,35.5,27.5c8.2,13.2,11.4,47.6-15.4,57s-44.9-13.1-55-12.7 c-18.1,0.7-28.2,23.5-49.6,19.4c-21.5-4-32.2-24.1-38.2-36.2c-6-12.1-14.2-6.8-31.5-2.7c-22.8,5.4-70.4,0-85.2-32.2 c-14.8-32.2-10.7-32.9-25.5-42.9c-14.8-10.1-38.2,8-63-7.4c-20.5-12.8-21.8-44.3-21.5-57c0.7-24.8-17.4-49.6-42.2-56.3 c-24.8-6.7-36.2,2.7-57.7-8c-21.5-10.7-27.5-29.5-34.2-44.3s-37.5-28.8-37.5-28.8L612.2,567.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20007",
    className: "st2",
    d: "M637.9,577.2c0,0,7.8-22.8-9-23.4c-16.8-0.6-17.4,23.4-14.4,31.8c1.5,4.3,3.3,8.5,5.4,12.6 c0,0-13.8,24.6,0,45.5c13.8,21,31.8,22.2,47.9,18.6s43.7-31.8,43.7-31.8c-6.5-11.7-12.1-24-16.8-36.5c-5.4-16.2-9-32.3-9-32.3 c-6.1,5.4-13.2,9.5-21,12C656,575.9,647,577.1,637.9,577.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20008",
    className: "st4",
    d: "M625,591.4h-0.1c-0.9-0.1-1.6-0.8-1.5-1.7c0,0,0,0,0,0c0-0.2,1.2-18.6,0.9-26.2 c0-0.9,0.6-1.7,1.5-1.7c0.9,0,1.7,0.6,1.7,1.5c0,0,0,0,0,0c0.3,7.8-0.9,25.8-0.9,26.5C626.6,590.8,625.9,591.4,625,591.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20009",
    className: "st4",
    d: "M665.9,636.5c-2.1-0.1-4.1-0.9-5.6-2.3c-0.7-0.6-0.8-1.6-0.2-2.3c0.6-0.7,1.6-0.8,2.3-0.2 c1.2,1.3,3,1.8,4.7,1.3c2.1-1.2,3.4-3.3,3.7-5.7c0.6-4.3,4.2-12.9,8.2-13.9c0.9-0.2,1.8,0.3,2,1.2c0.2,0.9-0.3,1.8-1.2,2 c-1.5,0.4-5,6.3-5.7,11.2c-0.4,3.5-2.5,6.7-5.7,8.3C667.6,636.3,666.8,636.5,665.9,636.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20010",
    className: "st4",
    d: "M665.1,644.7c-11.7,0-18.2-7.6-19.7-12.9c-0.2-0.9,0.3-1.8,1.1-2s1.8,0.3,2,1.1 c1.2,4.3,6.6,10.5,16.6,10.5h0.5c0.9,0,1.6,0.7,1.7,1.6c0,0.9-0.7,1.6-1.6,1.7L665.1,644.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20011",
    className: "st7",
    d: "M656.7,606.9c-1.4-1.1-1.3-2.8,0.3-4.8c1.7-2.1,3.2-2.6,4.6-1.5c1.4,1.1,1.3,2.8-0.3,4.8 C659.6,607.5,658.1,608,656.7,606.9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20012",
    className: "st7",
    d: "M687.9,630c-1.4-1.1-1.3-2.8,0.3-4.8c1.7-2.1,3.2-2.6,4.6-1.5c1.4,1.1,1.3,2.8-0.3,4.8 C690.9,630.6,689.3,631.1,687.9,630"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20013",
    className: "st4",
    d: "M678.7,600.6c-0.7,0-1.3-0.4-1.5-1c-3.6-6.6-10.4-10.9-17.9-11.1c-0.9-0.1-1.6-0.9-1.5-1.8 c0.1-0.9,0.8-1.6,1.7-1.5c0,0,0,0,0,0c8.7,0.4,16.6,5.4,20.7,13.1c0.3,0.8-0.1,1.8-0.9,2.1C679.1,600.6,678.9,600.6,678.7,600.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20014",
    className: "st4",
    d: "M707.7,626.7c-0.7,0-1.3-0.4-1.5-1c-3.6-6.6-10.4-10.9-17.9-11.1c-0.9-0.1-1.6-0.9-1.5-1.8 c0.1-0.9,0.8-1.6,1.7-1.5c0,0,0,0,0,0c8.7,0.4,16.6,5.4,20.7,13.1c0.3,0.8-0.1,1.8-0.9,2.1C708.1,626.7,707.9,626.7,707.7,626.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20015",
    className: "st8",
    d: "M634.8,614.7c-3.8-2.7-3.8-6.9,0.1-12.5c3.9-5.6,7.8-7.1,11.6-4.5s3.8,6.9-0.1,12.5 C642.6,615.8,638.7,617.3,634.8,614.7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20016",
    className: "st8",
    d: "M695.4,642.8c-2.8-3.7-7-3.5-12.5,0.7c-5.4,4.1-6.7,8.1-3.9,11.8c0.3,0.5,0.7,0.9,1.2,1.2 c5.7-3.6,11.1-7.7,16.2-12.1C696.1,643.9,695.8,643.4,695.4,642.8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20017",
    className: "st5",
    d: "M794.5,604.2c-0.3,0-0.6-0.1-0.9-0.2c-0.8-0.5-18.8-11.6-19.9-24.4c-0.9-11-7.6-29-19-32.8 c-0.9-0.3-1.3-1.2-1-2.1c0.3-0.9,1.2-1.3,2.1-1c13,4.3,20.2,23.4,21.2,35.6c0.9,11.1,18.2,21.8,18.3,21.9c0.8,0.5,1,1.5,0.5,2.3 C795.6,604,795.1,604.2,794.5,604.2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20018",
    className: "st5",
    d: "M862.9,551.6c-0.2,0-0.3,0-0.5-0.1c-0.6-0.2-15.6-5.1-19.8-19.2 c-3.6-12.2-19.9-19.6-30-19.6c-0.9,0-1.6-0.8-1.6-1.7c0-0.9,0.7-1.5,1.6-1.6c10.8,0,28.8,7.8,33.1,22c3.7,12.4,17.6,17,17.7,17 c0.9,0.3,1.3,1.2,1,2.1C864.2,551.2,863.6,551.6,862.9,551.6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20019",
    className: "st5",
    d: "M886.4,660.9c-0.5,0-1-0.3-1.3-0.7c-1.9-2.6-6.1-3.9-12-5.7c-3.4-1-7.2-2.2-11.4-3.8 c-13.1-5.1-13.8-25.7-13.1-28.7c0.2-0.9,1.1-1.4,2-1.2c0.9,0.2,1.4,1.1,1.2,2c-0.6,2.3,0.2,20.7,11.1,24.9 c4.1,1.6,7.9,2.7,11.2,3.7c6.5,2,11.2,3.4,13.7,6.9c0.5,0.7,0.4,1.8-0.4,2.3C887.1,660.8,886.8,660.9,886.4,660.9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20020",
    className: "st5",
    d: "M998.4,646.1c-0.6,0-1.2-0.4-1.5-1c-2.1-4.7-11.3-5.6-20.3-6.6c-3.2-0.3-6.4-0.7-9.4-1.2 c-5.5-1-10.4-5.4-14.2-12.7c-2.8-5.3-4.5-11-5.2-17c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.6,0.6,1.7,1.4c0.6,7.1,6.3,24.8,16.8,26.7 c2.8,0.5,6,0.8,9.2,1.2c9.8,1,20,2.1,22.9,8.5c0.4,0.8,0,1.8-0.8,2.2C998.8,646.1,998.6,646.1,998.4,646.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20021",
    className: "st5",
    d: "M936.7,764.8c-0.3,0-0.6-0.1-0.8-0.2c-10.1-6.1-16.8-19.4-17.6-34.9c0-0.9,0.7-1.7,1.6-1.7 c0.9,0,1.7,0.7,1.7,1.6c0.7,14.4,6.8,26.7,16,32.2c0.8,0.5,1,1.5,0.6,2.2C937.8,764.5,937.2,764.8,936.7,764.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20022",
    className: "st5",
    d: "M1037.9,784.9c-0.2,0-0.4,0-0.6-0.1c-0.9-0.3-23.1-8.6-23.9-21.6 c-0.7-12-10.6-28.4-19-31.4c-0.9-0.3-1.3-1.2-1-2.1c0.3-0.8,1.2-1.3,2.1-1c10.4,3.7,20.5,22.3,21.2,34.3 c0.6,10.8,21.5,18.6,21.7,18.7c0.9,0.3,1.3,1.2,1,2.1C1039.3,784.5,1038.6,785,1037.9,784.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20023",
    className: "st5",
    d: "M1127.8,790.3c-0.4,0-0.8-0.1-1.1-0.4c-2.5-2.2-6.4-3.2-11-4.2c-7-1.7-15-3.6-21.3-10.6 c-4.6-5.2-13.2-19.5-12.5-29.4c0.1-0.9,0.9-1.5,1.8-1.4c0.9,0.1,1.5,0.8,1.5,1.7c-0.6,8.5,7.2,21.8,11.7,27 c5.6,6.3,13,8.1,19.6,9.6c4.8,1.1,9.4,2.2,12.5,5c0.7,0.6,0.7,1.6,0.1,2.3C1128.7,790.1,1128.2,790.3,1127.8,790.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20024",
    className: "st5",
    d: "M1188.8,872.8c-0.9,0-1.6-0.7-1.6-1.6c0-5.4-7.6-16.1-17-19.2 c-10.2-3.4-14.7-14.9-13.9-24.5c0.1-0.9,0.9-1.5,1.8-1.4c0.8,0.1,1.5,0.8,1.4,1.7c-0.6,6.7,2.1,17.9,11.6,21.1 c10.3,3.4,19.2,15.2,19.2,22.3C1190.4,872,1189.7,872.8,1188.8,872.8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20025",
    className: "st5",
    d: "M1082.8,878.8c-0.6,0-1.2-0.3-1.5-0.9c-2.4-4.7-5.3-5.4-11.2-6.8 c-3.6-0.8-7.2-1.8-10.7-3.1c-14-5.2-16.5-17.8-17.2-26.9c0-0.9,0.7-1.7,1.6-1.7c0.9,0,1.6,0.6,1.7,1.5c0.6,8.2,2.8,19.5,15,24.1 c3.4,1.2,6.8,2.2,10.3,3c6,1.4,10.3,2.4,13.4,8.5c0.4,0.8,0.1,1.8-0.7,2.2C1083.3,878.8,1083.1,878.8,1082.8,878.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.1000a041e52f01e395dbb7cf9c175baf.svg";
export { ForwardRef as ReactComponent };